import React, { useState } from "react";
import { Row, Col, Button, Divider } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import "./Checkout.scss";
import AddAddressModal from "./AddAddressModal ";
import Payments from "../Payment/Payments";

const Checkout = () => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);

  const addresses = [
    {
      id: 1,
      name: "Alice Home",
      address: "1259, est 64th, Vancouver, zip: 123456",
    },
  ];

  const handleDeliverHere = (id:any) => {
    setSelectedAddress(id);
  };

  return (
    <Row gutter={30} className="address-layout">
      {/* Left Column */}
      <Col span={14} className="address-col">
        <div className="address-list">
          {addresses.map((item) => (
            <div
              key={item.id}
              className={`address-card ${
                selectedAddress === item.id ? "selected" : ""
              }`}
            >
              <div className="address-header">
                <EnvironmentOutlined className="map-icon" />
                <div>
                  <div className="address-name">{item.name}</div>
                  <div className="address-text">{item.address}</div>
                </div>
              </div>
              {selectedAddress === item.id ? null : (
                <Button
                  className="deliver-btn"
                  onClick={() => handleDeliverHere(item.id)}
                >
                  Deliver Here
                </Button>
              )}
            </div>
          ))}

          {/* Add new address card */}
          <div className="address-card add-new">
            <div className="address-header">
              <EnvironmentOutlined className="map-icon" />
              <div className="address-name">Add New Address</div>
            </div>
            <Button className="add-new-btn" onClick={() => setOpen(true)}>Add New</Button>
          </div>
        </div>

        {/* Proceed to Payment */}
        <Button
          className="proceed-btn"
          disabled={!selectedAddress}
          onClick={()=>setOpenPayment(true)}
        >
          Proceed to Payment
        </Button>
      </Col>

      {/* Right Column */}
      <Col span={10} className="order-col">
      <div className="order-items">
        <div className="restaurant-summary">
          <img
            src="https://via.placeholder.com/110x70"
            alt="Restaurant"
            className="restaurant-image"
          />
          <div>
            <div className="restaurant-name">Burrito Company</div>
            <div className="restaurant-place">Color Springs</div>
          </div>
        </div>
        <Divider/>
              <div style={{marginBottom:"20px"}}>Your Order - 2 Items</div>

              <div className="detail-orders">
                <div>
                   <div className="order-name-price" style={{marginBottom:"15px"}}>
                    <span> 1 X </span>
                    <span>Chicken Cheese Burrito</span>
                   </div>
                   <div className="single-price" style={{margin:"10px 30px"}}>$8.50</div>
                </div>
                <div className="order-name-price" >
                    $8.50
                </div>
              </div>

              </div>

               <div
                          style={{
                            background: "rgba(195, 35, 64, 0.05)",
                          }}
                        >
                          <div
                            style={{
                              padding: "15px 20px",
                              position: "relative",
                            }}
                          >
                            <div className="detail-orders order-name-price">
                              <div className="single-price">Items Cost</div>
                              <div className="single-price">$20.5</div>
                            </div>
                            <div className="detail-orders">
                              <div className="single-price">Taxes</div>
                              <div className="single-price">$20.5</div>
                            </div>
                            <div className="detail-orders single-price">
                              <div className="single-price">Tip</div>
                              <div className="single-price">$20.5</div>
                            </div>
                            <div className="detail-orders single-price">
                              <div className="single-price">Delivery Fees</div>
                              <div className="single-price">$20.5</div>
                            </div>
                            <Divider/>
              
                            <div className="detail-orders ">
                              <div className="order-name-price">Delivery Fees</div>
                              <div className="order-name-price">$20.5</div>
                            </div>
              
                          </div>
                        </div>
      </Col>

      <AddAddressModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={(vals:any) => {
          // handle newly added address
          console.log("Received:", vals);
        }}
      />
      <Payments
      open={openPayment}
      onClose={() => setOpenPayment(false)}
      />
    </Row>
  );
};

export default Checkout;
